import { ENDPOINT } from 'api/endPoints/getResourceChart';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const resourcesAnalysisChart: IHashmapItemComponentProps = {
    NoPermissionMessage,
    id: 'resourcesAnalysisChart',
    title: 'Resource Utilization Chart',
    componentKey: 'resourcesAnalysisChart',
    globalFiltersConfig: [
        { key: 'dateRangeFilter', name: 'dateRangeFilter', defaultValue: 'R_4W' },
        { key: 'quickAnswerFilter', name: 'quickAnswerFilter', defaultValue: null },
        { key: 'resourceType', name: 'resourceType', defaultValue: null },
        { key: 'resource', name: 'resource', defaultValue: null },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: MEDIUM,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
};
